/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberTransactionListOutput { 
    id?: number;
    accountType?: string | null;
    accountNumber?: string | null;
    amount?: number;
    transactionNumber?: string | null;
    transactionDate?: string;
    status?: string | null;
    mode?: string | null;
    channel?: string | null;
    debit?: number;
    credit?: number;
    creationDate?: string;
    description?: string | null;
    transactionType?: string | null;
}

